import React from 'react';
import { Home } from 'lucide-react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="foot-in">
        <div className="foot-top">
          <div className="foot-brand">
            <div className="foot-logo">
              <div className="foot-logo-box">
                <Home size={18} color="#fff" strokeWidth={2} />
              </div>
              <div className="foot-logo-text">
                HomeWarranty<span>USA</span>
              </div>
            </div>
            <p>
              America's trusted home warranty marketplace. Compare plans, get instant
              quotes, and protect your home in minutes.
            </p>
          </div>

          <div className="foot-col">
            <h4>Coverage</h4>
            <ul>
              <li><a href="#coverage">HVAC Systems</a></li>
              <li><a href="#coverage">Plumbing</a></li>
              <li><a href="#coverage">Electrical</a></li>
              <li><a href="#coverage">Appliances</a></li>
              <li><a href="#coverage">Add-Ons</a></li>
            </ul>
          </div>

          <div className="foot-col">
            <h4>Plans</h4>
            <ul>
              <li><a href="#plans">Systems Plan</a></li>
              <li><a href="#plans">Comprehensive</a></li>
              <li><a href="#plans">Premium Plan</a></li>
              <li><a href="#quote-section">Get a Quote</a></li>
            </ul>
          </div>

          <div className="foot-col">
            <h4>Company</h4>
            <ul>
              <li><a href="#top">About Us</a></li>
              <li><a href="#faq">FAQ</a></li>
              <li><a href="#reviews">Reviews</a></li>
              <li><a href="#top">Contact</a></li>
              <li><a href="tel:18005550100">(800) 555-0100</a></li>
            </ul>
          </div>
        </div>

        <div className="foot-bot">
          <p>© 2025 HomeWarrantyUSA.us · All rights reserved · homewarrantyusa.us</p>
          <div className="foot-legal">
            <a href="#top">Privacy Policy</a>
            <a href="#top">Terms of Service</a>
            <a href="#top">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
